// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jb71WVxYSgv0QF .qTinKf_lscaMce {
  display: block;
}
.jb71WVxYSgv0QF .IDG29wcolRQ4V5 {
  display: none;
}
.jb71WVxYSgv0QF:hover .qTinKf_lscaMce,
.jb71WVxYSgv0QF:active .qTinKf_lscaMce {
  display: none;
}
.jb71WVxYSgv0QF:hover .IDG29wcolRQ4V5,
.jb71WVxYSgv0QF:active .IDG29wcolRQ4V5 {
  display: block;
}
.jb71WVxYSgv0QF:hover .IDG29wcolRQ4V5 svg {
  color: var(--tr-icon-star);
}
.jb71WVxYSgv0QF:active .IDG29wcolRQ4V5 svg {
  color: var(--ds-icon-disabled, #091e424f);
}
.ElkDUyE652WfYK .qTinKf_lscaMce {
  display: none;
}
.ElkDUyE652WfYK .IDG29wcolRQ4V5 {
  display: block;
}
.ElkDUyE652WfYK:hover .qTinKf_lscaMce {
  display: none;
}
.ElkDUyE652WfYK:hover .IDG29wcolRQ4V5 {
  display: block;
}
.ElkDUyE652WfYK:hover .IDG29wcolRQ4V5 svg {
  color: var(--tr-icon-star);
}
.ElkDUyE652WfYK:active .qTinKf_lscaMce {
  display: block;
}
.ElkDUyE652WfYK:active .IDG29wcolRQ4V5 {
  display: none;
}
.I_NWGXy72kUkhV:hover .IDG29wcolRQ4V5 svg,
.I_NWGXy72kUkhV:active .IDG29wcolRQ4V5 svg {
  color: var(--dynamic-icon);
}
.C4EaJX6ujhCZyw:hover .IDG29wcolRQ4V5 svg {
  color: var(--dynamic-icon);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"starredBoardIcon": `jb71WVxYSgv0QF`,
	"starredIcon": `qTinKf_lscaMce`,
	"starIcon": `IDG29wcolRQ4V5`,
	"unstarredBoardIcon": `ElkDUyE652WfYK`,
	"starredBoardIconCustomStarColor": `I_NWGXy72kUkhV`,
	"unstarredBoardIconCustomStarColor": `C4EaJX6ujhCZyw`
};
export default ___CSS_LOADER_EXPORT___;
